<template>
  <div class="container">
    <!-- 性别分布 -->
    <div class="cards-sex" id="cards-box">
      <div class="cards-title">
        <span>{{ genderdistribution }}</span>
      </div>
      <div class="cards-shaw"></div>
      <div class="drawPadding">
        <!-- <div class="loadbox">
          <van-loading type="spinner" color="#1989fa" />
        </div> -->
        <Empty v-if="isSex" />
        <FszPie v-else :data="sexDataPie" height="281px"></FszPie>
      </div>
    </div>
    <!-- 点突变 -->
    <div class="snv-box" v-if="$route.query.type == 0">
      <div class="cards-title title">
        <h2>点突变/插入/缺失</h2>
        <p>
          <span @click="snvAll()">{{ headView }}</span>
          <i class="iconfont icon-right_small titleView"></i>
        </p>
      </div>
      <div class="cards-shaw"></div>
      <!-- <Empty v-if="isSnv" /> -->
      <div class="null-box" v-if="isSnv">
      <van-empty
        class="custom-image"
        image-size="100px"
        :image="require('../../assets/not.png')"
        description="未检出"
      />
    </div>
      <MutationList
        @geneSnvClick="geneSnvClick"
        @anClick="anClick"
        v-else
        :snvList="snvList"
      />
    </div>
    <!-- 拷贝数 -->
    <div class="cnv-box" v-if="$route.query.type == 0">
      <cards_table
        :headName="headProduct"
        :titleData="titleProduct"
        :tableData="cnvList"
        @cnvClick="cnvClick"
        :isNull="isNull"
      ></cards_table>
    </div>

    <!-- 基因重排 -->
    <div class="gene-box" v-if="$route.query.type == 0">
      <cards_table
        :headName="headName"
        :headView="headView"
        :titleData="titleData"
        :tableData="tableData"
        @geneClick="geneClick"
        @geneYangban="geneYangban"
        @geneAll="geneAll"
        @ceiliingAnalysis="ceiliingAnalysis"
        :flag="true"
      ></cards_table>
    </div>

    <!-- 癌种 -->
    <div class="ai-box">
      <cards_table
        :headName="headCancer"
        :headView="headView"
        :titleData="titleCanner"
        :tableData="cancerData"
        @aiYangben="aiYangben"
        @cancerName="cancerName"
        :color1="'#4B84FF'"
        @geneAi="geneAi"
      ></cards_table>
    </div>

    <!-- 年龄分布 -->
    <div class="cards-age">
      <div class="cards-title">
        <span>{{ agedistribution }}</span>
      </div>
      <div class="cards-shaw"></div>
      <div class="null-box" v-if="isEmpty">
        <van-empty
          class="custom-image"
          :image="require('../../assets/null-data.png')"
          description="暂无数据"
        />
      </div>
      <FszBar v-else :data="dataBar" height="381px"></FszBar>
    </div>
  </div>
</template>

<script>
import isiOS from "../../utils/iosAn";
import MutationList from "./compontents/mutationList.vue";
// import F2 from "@antv/f2/lib/index-all";
import { Toast } from "vant";
import {
  Gender,
  findSNVResult,
  findCNVResult,
  findSVResult,
  findSampleCancer,
  findSampleAge,
} from "@/api/dataStatistics.js";
import * as echarts from "echarts";
import cards_table from "./compontents/geneTableList";
import { da } from 'date-fns/locale';
export default {
  components: {
    cards_table,
    MutationList,
  },
  data() {
    return {
      isNull: false,
      isSnv: false,
      isSex: false,
      isEmpty: false,
      cnvList: [],
      snvList: [],
      id: 12336666,
      // 折线图
      // dataLine: {
      //     chartLineData: [
      //         {
      //             name: "折线1",
      //             color: "#6395F9",
      //             data: []
      //         },
      //         {
      //             name: "折线2",
      //             color: "#62DAAB",
      //             data: []
      //         }
      //     ],
      //     chartLineAxis: []
      // },
      // 柱状
      dataBar: {
        chartBarData: [
          {
            // name: "产出医院数量",
            // color: "#6395F9",
            data: [],
          },
          // {
          //     name: "产出医生数量",
          //     color: "#62DAAB",
          //     data: []
          // },
          // {
          //     name: "产出科室数量",
          //     color: "#F6C022",
          //     data: []
          // }
        ],
        chartBarAxis: [],
      },
      // 饼图
      dataPie: {
        chartPieData: [
          {
            name: "报药比例",
            color: "#3186FF",
            data: [],
          },
        ],
      },
      sexDataPie: {
        chartPieData: [
          {
            name: "性别分布",
            color: "#3186FF",
            data: [],
            title: {},
          },
        ],
      },

      samplenum: null,
      genderdistribution: "性别分布",
      agedistribution: "年龄分布",
      headName: "基因重排",
      headView: "查看全部",
      headCancer: "癌种",
      headProduct: "拷贝数",
      titleCanner: [
        {
          name: "名称",
          samplenum: "样本数",
          percentage: "占比(%)",
        },
      ],
      titleProduct: [
        {
          name: "基因",
          samplenum: "突变类型",
          percentage: "阳性样本",
        },
      ],
      titleData: [
        {
          name: "Gene",
          samplenum: "突变样本数",
          percentage: "占比(%)",
        },
      ],
      tableData: [],
      cancerData: [],
      productData: [],
    };
  },
  methods: {
    /**点突变-点击氨基酸*/
    anClick(param) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    /**点突变-点击阳性患者*/
    geneSnvClick(param) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    /**点突变查看全部 */
    snvAll() {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "snv",
          fromSource: "snv",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({ name: "snv", fromSource: "snv" })
        );
      }
    },
    /**获取年龄分布接口 */
    async getAge(geneName, variationType) {
      try {
        let { data } = await findSampleAge({
          geneName: geneName,
          tag: "gene",
          variationType: variationType,
        });
        if (data == "" || data == [] || data == null) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        data.forEach((item) => {
          this.dataBar.chartBarAxis.push(item.ageProportion);
          this.dataBar.chartBarData[0].data.push(item.ageCount);
        });
      } catch (err) {}
    },

    /**获取癌种数据接口 */
    async getCancer(geneName, variationType) {
      try {
        let { data } = await findSampleCancer({
          geneName: geneName,
          pageSize: 5,
          current: 1,
          tag: "gene",
          variationType: variationType,
        });

        this.cancerData = data.map((item) => {
          return {
            name: item.cancerOne,
            samplenum: item.geneCount,
            percentage: item.genePercent,
          };
        });
      } catch (err) {}
    },
    /**获取基因数据接口 */
    async getSv(geneName, variationType) {
      try {
        let { data } = await findSVResult({
          mainGene: geneName,
          pageSize: 5,
          current: 1,
          variationType: variationType,
        });

        this.tableData = data.records.map((item) => {
          return {
            name: item.fusionPair,
            samplenum: item.cohort,
            percentage: item.proportion,
          };
        });
      } catch (error) {}
    },
    /**拷贝数接口 */
    async getCnv(geneName, variationType) {
      try {
        let { data } = await findCNVResult({
          gene: geneName,
          pageSize: 5,
          current: 1,
          variationType: variationType,
        });
        this.cnvList = data.records.map((item) => {
          return {
            name: item.gene,
            samplenum: item.cnvResult,
            percentage: item.cohort,
          };
        });
      } catch (error) {}
    },

    /**点突变插入缺失接口 */
    async getSnv(geneName, variationType) {
      try {
        let { data } = await findSNVResult({
          geneName: geneName,
          pageSize: 5,
          current: 1,
          variationType: variationType,
        });
        this.snvList = data.records;
        if (data.records == "") {
          this.isSnv = true;
        } else {
          this.isSnv = false;
        }
      } catch (error) {
        this.isSnv = true;
      }
    },
    /**获取性别数据接口 */
    async getGender(geneName, variationType) {
      try {
        let { data } = await Gender({
          variationType: variationType,
          geneName: geneName,
          tag: "gene",
        });
        this.sexData = data;
        console.log(data,'datatat')
        if (this.sexData == "") {
          this.isSex = true;
        } else {
          this.isSex = false;
        }
        var unknown;

        if (data[2].sexCount == 0) {
          unknown = "";
        } else {
          unknown = data[2].sexCount;
        }
        this.sexDataPie.chartPieData[0].data = [
          { value: data[0].sexCount, name: data[0].sex + "性" },
          { value: data[1].sexCount, name: data[1].sex + "性" },
          { value: data[2].sexCount, name: data[2].sex },
        ];
        let subtext =
          data[0].sexCount + data[1].sexCount + data[2].sexCount;
        this.sexDataPie.chartPieData[0].title = {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: subtext,
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 70,
        };
      } catch (err) {}
    },
    ceiliingAnalysis(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
    },
    // 癌种-点击样本数
    aiYangben(param) {
      console.log(param, 2121212);
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 癌种-点击名称
    cancerName(param) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 癌肿查看全部
    geneAi(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(type);
      } else {
        window.android.JSCallNative(JSON.stringify(type));
      }
    },
    // 拷贝数
    cnvClick(param) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因重排-点击基因
    geneClick(param) {
      console.log(param, "保留先不做跳转");
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因重排-点击样本数
    geneYangban(param) {
      console.log(param, "222222");
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因重排-查看全部

    geneAll(name) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(name);
      } else {
        window.android.JSCallNative(JSON.stringify(name));
      }
      console.log(arg);
      // this.$router.push({
      //   name: "mutationfrequency",
      //   params: {},
      // });
    },
    initLineChartData() {
      //   this.dataLine.chartLineData.forEach(element => {
      //     element.data = [];
      //   });
      this.dataBar.chartBarData.forEach((element) => {
        element.data = [];
      });
      this.dataPie.chartPieData.forEach((element) => {
        element.data = [];
      });
      this.sexDataPie.chartPieData.forEach((element) => {
        element.data = [];
      });
      setTimeout(() => {
        // this.dataLine.chartLineData[0].data.push(
        //   120,
        //   132,
        //   101,
        //   134,
        //   90,
        //   230,
        //   210
        // );
        // this.dataLine.chartLineData[1].data.push(
        //   108,
        //   125,
        //   148,
        //   136,
        //   99,
        //   87,
        //   148
        // );
        // this.dataLine.chartLineAxis.push(
        //   "01/01",
        //   "01/02",
        //   "01/03",
        //   "01/04",
        //   "01/05",
        //   "01/06",
        //   "01/07"
        // );
        // 柱状图
        // this.dataBar.chartBarData[1].data.push(
        //     6,
        //     7,
        //     9,
        //     8,
        //     8,
        //     9,
        //     11,
        //     9,
        //     7,
        //     5,
        //     9,
        // );
        // this.dataBar.chartBarData[2].data.push(
        //     6,
        //     18,
        //     15,
        //     19,
        //     13,
        //     13,
        //     15,
        //     3,
        //     6,
        //     8,
        //     18,
        // );
        // 饼图
      }, 1000);

      // 调接口
      // consultTreeData(this.param).then(res => {
      //   // 清空数据
      //   this.data.chartLineData.forEach(element => {
      //     element.data = [];
      //   });
      //   this.data.chartLineAxis = []
      //   res.param.forEach(element => {
      //     this.data.chartLineData[0].data.push(element.wzCount);
      //     this.data.chartLineData[1].data.push(element.fzCount);
      //     this.data.chartLineAxis.push(this.formatYearMonth(element.dateTime));
      //   });
      // });
    },

    columnar() {
      const data = [
        {
          year: "18-30",
          sales: 2751,
        },
        {
          year: "30-35",
          sales: 8912,
        },
        {
          year: "45-55",
          sales: 14572,
        },
        {
          year: "55-65",
          sales: 22077,
        },
        {
          year: "65-75",
          sales: 17992,
        },
        {
          year: ">75",
          sales: 15951,
        },
      ];
      const chart = new F2.Chart({
        id: "chartage",
        pixelRatio: window.devicePixelRatio,
        width: document.getElementById("cards-box").offsetWidth,
        height: document.getElementById("chartbox1").offsetHeight,
      });
      chart.source(data, {
        sales: {
          tickCount: 5,
        },
      });
      chart.tooltip({
        showItemMarker: false,
        onShow: function onShow(ev) {
          const items = ev.items;
          items[0].name = null;
          items[0].name = items[0].title;
          items[0].value = "¥ " + items[0].value;
        },
      });
      chart.legend({
        nameStyle: {
          fontSize: 13,
        },
      });
      chart
        .interval()
        .position("year*sales")
        .color("l(90) 0:#4B84FF 1:#52E4C9"); // 定义柱状图渐变色
      chart.render();
    },
    funTest() {
      var _this = this;
      var lineWidth = document.getElementById("twChart");
      lineWidth.style.width = window.innerWidth - 24 + "px";
      this.chart = echarts.init(lineWidth);
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("twChart"));
      // var chartDom = document.getElementById('twChart');
      // var myChart = echarts.init(chartDom);
      // window.onresize = myChart.resize;
      // let myChart = this.$echarts.init(document.getElementById('twChart'))
      // let listener = function () {
      //     myChat.resize()
      // }
      // window.addEventListener('resize', listener)

      var option = {
        color: ["#4B84FF", "#27CA8D", "#626C91"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "0%",
          left: "center",
          itemHeight: 6,
          itemWidth: 6,
          itemGap: 70,
          icon: "circle",
        },
        title: {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: "21323",
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 90,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["55%", "70%"],
            avoidLabelOverlap: false,

            label: {
              //展示文本设置
              normal: {
                show: true, //展示
                position: "outside", // outside表示文本显示位置为外部
              },
              emphasis: {
                //文本样式
                show: true, //展示
                textStyle: {
                  //文本样式
                  fontSize: "14",
                  fontWeight: "600",
                },
              },
            },
            labelLine: {
              //引导线设置
              normal: {
                show: false, //引导线显示
              },
            },
            data: [
              { value: 50, name: "男性" },
              { value: 48, name: "女性" },
              { value: 2, name: "未知" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
  created() {
    this.initLineChartData();
  },
  mounted() {
    // this.getGender();
    // this.getSnv();
    // this.getCnv();
    // this.getSv();
    // this.getCancer();
    // this.getAge();
  },
  beforeRouteEnter: (to, from, next) => {
    window.NativeCallJS = (res) => {
      var par = JSON.parse(res);
      console.log("进入页面");
      console.log("获取app传值", par);
      next((vm) => {
        vm.getGender(par.gene, par.variationType);
        vm.getAge(par.gene, par.variationType);
        vm.getCancer(par.gene, par.variationType);

        if (vm.$route.query.type == 0) {
          vm.getSnv(par.gene, par.variationType);
          vm.getCnv(par.gene, par.variationType);
          vm.getSv(par.gene, par.variationType);
        }
      });
    };
  },
};
</script>
<style lang="less" scoped>
/deep/.van-empty__description{
  margin-top: 0;
}
/deep/.van-empty{
  padding: 20PX 0 30PX;
}
.container {
  padding-bottom: 20px;
}
/deep/.ai-box {
  .genne-mutaion-head {
    span {
      &:nth-child(1) {
        width: 50%;
      }
      &:nth-child(2) {
        width: 30%;
      }
      &:nth-child(3) {
        width: 20%;
      }
    }
  }
  .genne-mutaion-content {
    span {
      &:nth-child(1) {
        width: 50%;
      }
      &:nth-child(2) {
        width: 30%;
        color: #4b84ff;
      }
      &:nth-child(3) {
        width: 20%;
      }
    }
  }
}
/deep/.gene-box {
  .mutaion-tab-box {
    display: none;
  }
  .genne-mutaion-head {
    span {
      &:nth-child(1) {
        width: 50%;
      }
      &:nth-child(2) {
        width: 30%;
      }
      &:nth-child(3) {
        width: 20%;
      }
    }
  }
  .genne-mutaion-content {
    span {
      &:nth-child(1) {
        width: 50%;
        color: #4b84ff;
        font-weight: 500;
      }
      &:nth-child(2) {
        width: 30%;
        color: #4b84ff;
        font-weight: 500;
      }
      &:nth-child(3) {
        width: 20%;
      }
    }
  }
}
/deep/.snv-box {
  width: 343px;
  margin: 20px auto 0;
  border-radius: 10px;
  background: @background_color;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    h2 {
      font-size: 18px;
      font-weight: 500;
      color: #2f354d;
    }
    p {
      color: #4b84ff;
      font-size: 12px;

      i {
        font-size: 12px;
        color: #4b84ff;
      }
    }
  }
  .mutation-main {
    background: none;
    .show-box {
      display: none;
    }
  }
}

/deep/.cnv-box {
  .genne-mutaion-content {
    span {
      &:nth-child(1) {
        width: 33%;
      }
      &:nth-child(2) {
        width: 33%;
      }
      &:nth-child(3) {
        width: 33%;
      }
    }
  }
}
/deep/.cnv-box .genne-mutaion-content {
  span {
    &:last-child {
      color: #4b84ff;
      font-weight: 600;
    }
  }
}
/deep/.cnv-box .titleView {
  display: none;
}
/deep/.cnv-box .genne-mutaion-head {
  display: flex;
  justify-content: space-between;
}
/deep/.cnv-box .genne-mutaion-head span {
  flex: 1;
}
.loadbox {
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drawPadding {
  padding-left: 24px;
  padding-right: 24px;
  position: relative;
}

.chartsexNum > span {
  /* width: 33.3%; */
  /* text-align: right; */
  margin-left: 58px;
  display: inline-block;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2f354d;
  line-height: 22px;
}

/* 性别分布 */
.cards-sex {
  width: 343px;
  height: auto;
  background: @background_color;
  border-radius: 10px;
  margin: 0 auto;
}

.cards-title {
  height: 70px;
}

.cards-title > span:nth-of-type(1) {
  display: inline-block;
  font-size: 18px;
  font-family: @family;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
  line-height: 70px;
}

.cards-title > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  /* float: right; */
  margin-right: 3px;
  line-height: 70px;
}

.cards-shaw {
  display: inline-block;
  width: 343px;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
}

.smple {
  color: red !important;
  font-size: 26px;
}

/* 年龄分布 */
.cards-age {
  width: 343px;
  height: auto;
  background: @background_color;

  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}

/* 报药比例 */
.cards-drug {
  width: 343px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
